import React from "react";
import {Helmet} from "react-helmet";
import {ViviaWisperwind} from "../../constants/meta";

export const A37Meta = () => (
    <Helmet>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Jacqueline van den Berg"/>
        <meta name="twitter:description"
              content=". Jacqueline van den Berg is a painter and photographer. Her work exists at the intersection of emotion, observation, and freedom.  "/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_jacqueline_van_den_berg.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Jacqueline van den Berg"/>
        <meta property="og:description"
              content=" Jacqueline van den Berg is a painter and photographer. Her work exists at the intersection of emotion, observation, and freedom.  "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ jacqueline_van_den_berg.jpg"/>


    </Helmet>);